import { omit } from 'lodash';

import { NormalizedCart } from '../../types';
import { OutgoingMembershipProductDto } from 'api/dtos/memberships/products';

const DEFAULT_PRODUCT_QUANTITY = 1;

/**
 * Toggle a product in a normalized cart object.
 */
const toggleProduct = (
  cart: NormalizedCart,
  toggledProduct: OutgoingMembershipProductDto
): NormalizedCart => {
  if (cart[toggledProduct.product.id]) {
    return omit(cart, toggledProduct.product.id);
  }

  return {
    ...cart,
    [toggledProduct.product.id]: {
      productData: toggledProduct,
      metadata: { quantity: DEFAULT_PRODUCT_QUANTITY }
    }
  };
};

export default toggleProduct;
